// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle6NewForm from "../../randing/RandingStyle6NewForm";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing052({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/052/25010301.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/052/25010302.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/028/01_241212_04.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/052/25010303.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      qOptionColor="red"
      privacyMessage="개인정보수집에 동의하시는 분만'신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/costCheckButton.png`}
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
    />
  );
}

export default Randing052;
